// extracted by mini-css-extract-plugin
export var active = "_2b-b";
export var activeIndicator = "_2b-6";
export var animate = "_2b-a";
export var disabled = "_2b-c";
export var flat = "_2b-1";
export var fullWidth = "_2b-3";
export var lg = "_2b-9";
export var md = "_2b-8";
export var redoButtonTabGroup = "_2b-0";
export var sm = "_2b-7";
export var tabButton = "_2b-4";
export var tabButtonsContainer = "_2b-2";
export var xs = "_2b-5";